import React from "react";
import "./termsOfUse.css";

export default function NewTermsOfUse(props) {
  return (
    <div id="terms-of-use">
      <p style={{ textAlign: "right", fontStyle: "italic", marginBottom: 8 }}>
        Última atualização: 21/05/2026
      </p>

      <p>
        <b>
          Termo de uso do sistema Estes são nossos termos para uso da ferramenta
          que determinarão nossa relação. Caso não concorde, não avance na
          criação da sua conta. Antes de utilizar o MercadoAgentes, é necessário
          que o CONTRATANTE leia, entenda e concorde com estes termos.
        </b>
      </p>
      <p>
        Este Contrato de Licença de Uso de Usuário Final ("CLUF") é um acordo
        legal entre o CONTRATANTE (pessoa física ou jurídica) e UPSOFT
        TECNOLOGIA LTDA., pessoa jurídica de direito privado, inscrita no CNPJ
        sob o nº 61.304.434/0001-70, doravante denominada "MercadoAgentes", por
        meio de seu nome fantasia, e define as condições pelas quais o
        CONTRATANTE poderá acessar e utilizar as funcionalidades do programa de
        computador denominado MercadoAgentes, disponibilizado em ambiente web
        sob a modalidade Software as a Service (SaaS) e seu uso limitado a estas
        condições de licenciamento pelo prazo determinado pelo LICENCIADO no ato
        do licenciamento do SOFTWARE, o que inclui o programa de computador e
        pode incluir documentação "online" ou eletrônica. Ao utilizar o
        SOFTWARE, mesmo que parcial ou a título de teste, o licenciado estará
        vinculado aos termos deste "CLUF", concordando com os mesmos. O
        tratamento de dados pessoais necessário ao acesso, coleta, uso,
        armazenamento e proteção das informações do LICENCIADO fundamenta-se,
        principalmente, na <b>execução deste contrato</b> e nas demais bases
        legais descritas na cláusula 20, sendo o consentimento exigido apenas
        para finalidades que dele dependam. Em caso de discordância dos termos
        aqui apresentados, a utilização do SOFTWARE deve ser imediatamente
        interrompida.
      </p>
      <p>
        Informações adicionais sobre este CLUF podem ser estabelecidas através
        de PROPOSTAS que serão partes integrantes deste CLUF. Havendo
        divergências entre as disposições do presente CLUF e os termos das
        PROPOSTAS, prevalecerão as disposições do CLUF.
      </p>
      <p>
        AO MANIFESTAR SEU "ACEITE" CONCORDANDO COM OS TERMOS ESTABELECIDOS NESTE
        CLUF O CONTRATANTE TERÁ ACESSO AOS SERVIÇOS DISPONIBILIZADOS ATRAVÉS
        DESTE INSTRUMENTO, ACATARÁ, SE SUJEITANDO ÀS OBRIGAÇÕES NESTE CLUF
        PREVIAMENTE ACORDADAS. AO DAR SEU "ACEITE" o CONTRATANTE DECLARA
        EXPRESSAMENTE QUE LEU, ENTENDEU E COMPREENDEU TODOS OS DIREITOS E
        OBRIGAÇÕES DETERMINADOS POR ESTE CLUF. CASO NÃO CONCORDE COM QUALQUER
        DOS TERMOS DESTE CONTRATO, o CONTRATANTE NÃO DEVERÁ AVANÇAR PARA CRIAR
        UMA CONTA. SE FIZER POR ENGANO, DEVERÁ NOTIFICAR O MERCADOAGENTES SOBRE
        A NÃO CONCORDÂNCIA IMEDIATAMENTE, O QUE IMPEDIRÁ A FORMAÇÃO DESTE
        INSTRUMENTO, E, CONSEQUENTEMENTE A INTERRUPÇÃO DO ACESSO À FERRAMENTA E
        AOS DADOS NELA GERADOS EM SEU FAVOR DE QUALQUER SERVIÇO DISPONIBILIZADO
        PELO MERCADOAGENTES A QUALQUER TEMPO.
      </p>

      {/* CLÁUSULA 1 - OBJETO */}
      <h5><u>1. Objeto</u></h5>
      <p>
        1.1. Sob os termos e condições deste instrumento, a CONTRATADA prestará
        ao CONTRATANTE os serviços consistentes na implementação e
        disponibilização para uso da plataforma denominada MercadoAgentes, que
        possui funcionalidade voltada para gestão e criação de agentes de
        inteligência artificial (IA), permitindo que o CONTRATANTE utilize o
        software para oferecer serviços de IA aos seus próprios clientes.
      </p>
      <p>
        1.1.1. A plataforma MercadoAgentes é licenciada <b>exclusivamente</b> para
        fins de criação, configuração e disponibilização de agentes de inteligência
        artificial destinados ao cliente final do CONTRATANTE, seja este pessoa
        física ou jurídica, para uso próprio e operacional.
      </p>
      <p>
        1.2. O serviço é disponibilizado por meio de planos, os quais poderão
        ser alterados mediante solicitação de upgrade e cujas condições e
        recursos podem ser ajustados a qualquer tempo, pela CONTRATADA, mediante
        aviso prévio.
      </p>
      <p>
        1.3. Os planos atualmente oferecidos compreendem duas modalidades: <b>Uso Pessoal</b> e <b>Uso Comercial (White Label)</b>.
      </p>

      <p><b>1.3.1. PLANOS DE USO PESSOAL</b></p>

      {/* PLANO STARTER PESSOAL */}
      <p><b>a) Plano Starter — R$ 347,00/mês:</b></p>
      <ul>
        <li>1 (um) agente publicado</li>
        <li>Agentes ilimitados para testes no Playground</li>
        <li>1 (uma) instância WhatsApp</li>
        <li>2 (dois) usuários</li>
        <li>1.000 (mil) clientes na base</li>
        <li>1.000 (mil) contatos no Pipeline CRM</li>
        <li>2.000 (duas mil) mensagens WhatsApp por mês</li>
        <li>2 (duas) agendas</li>
        <li>50 (cinquenta) produtos</li>
        <li>Plataforma de gestão completa</li>
        <li>Chat estilo WhatsApp Web</li>
        <li>Tags ilimitadas</li>
        <li>Suporte via Chat</li>
      </ul>

      {/* PLANO BUSINESS PESSOAL */}
      <p><b>b) Plano Business — R$ 497,00/mês:</b></p>
      <ul>
        <li>1 (um) agente publicado</li>
        <li>Agentes ilimitados para testes no Playground</li>
        <li>1 (uma) instância WhatsApp</li>
        <li>3 (três) usuários</li>
        <li>3.000 (três mil) clientes na base</li>
        <li>3.000 (três mil) contatos no Pipeline CRM</li>
        <li>5.000 (cinco mil) mensagens WhatsApp por mês</li>
        <li>10 (dez) agendas</li>
        <li>50 (cinquenta) produtos</li>
        <li>Plataforma de gestão completa</li>
        <li>Chat estilo WhatsApp Web</li>
        <li>Tags ilimitadas</li>
        <li>Suporte via Chat</li>
      </ul>

      <p><b>1.3.2. PLANOS DE USO COMERCIAL (WHITE LABEL)</b></p>

      {/* PLANO WHITE LABEL */}
      <p><b>c) Plano White Label — R$ 497,00/mês:</b></p>
      <ul>
        <li>Marca personalizada (White Label) — ativada após o pagamento do plano</li>
        <li>3 (três) subcontas (adicional disponível)</li>
        <li>1 (uma) instância WhatsApp (adicional disponível)</li>
        <li>1 (um) agente publicado por subconta</li>
        <li>2 (dois) usuários por subconta (adicional disponível)</li>
        <li>1.000 (mil) clientes (adicional disponível)</li>
        <li>1.000 (mil) contatos no Pipeline CRM (adicional disponível)</li>
        <li>5.000 (cinco mil) mensagens WhatsApp por mês por subconta (adicional disponível)</li>
        <li>2 (duas) agendas (adicional disponível)</li>
        <li>Plataforma de gestão completa</li>
        <li>Chat estilo WhatsApp Web</li>
        <li>Playground de testes</li>
        <li>Tags ilimitadas</li>
        <li>Suporte via WhatsApp</li>
      </ul>

      {/* PLANO WHITE LABEL PLUS */}
      <p><b>d) Plano White Label Plus — R$ 897,00/mês:</b></p>
      <ul>
        <li>Marca personalizada (White Label) — ativada após o pagamento do plano</li>
        <li>6 (seis) subcontas (adicional disponível)</li>
        <li>1 (uma) instância WhatsApp (adicional disponível)</li>
        <li>1 (um) agente publicado por subconta</li>
        <li>3 (três) usuários por subconta (adicional disponível)</li>
        <li>2.000 (duas mil) clientes por subconta (adicional disponível)</li>
        <li>2.000 (duas mil) contatos no Pipeline CRM por subconta (adicional disponível)</li>
        <li>7.500 (sete mil e quinhentas) mensagens WhatsApp por mês por subconta (adicional disponível)</li>
        <li>5 (cinco) agendas por subconta (adicional disponível)</li>
        <li>Plataforma de gestão completa</li>
        <li>Chat estilo WhatsApp Web</li>
        <li>Playground de testes</li>
        <li>Tags ilimitadas</li>
        <li>Suporte via WhatsApp</li>
      </ul>

      {/* PLANO WHITE LABEL PRO */}
      <p><b>e) Plano White Label Pro — R$ 1.497,00/mês:</b></p>
      <ul>
        <li><b>INCLUSO: 1 (uma) hora de consultoria por mês</b></li>
        <li>Marca personalizada (White Label) — ativada após o pagamento do plano</li>
        <li>10 (dez) subcontas (adicional disponível)</li>
        <li>1 (uma) instância WhatsApp (adicional disponível)</li>
        <li>1 (um) agente publicado por subconta</li>
        <li>5 (cinco) usuários por subconta (adicional disponível)</li>
        <li>3.000 (três mil) clientes por subconta (adicional disponível)</li>
        <li>3.000 (três mil) contatos no Pipeline CRM por subconta (adicional disponível)</li>
        <li>10.000 (dez mil) mensagens WhatsApp por mês por subconta (adicional disponível)</li>
        <li>10 (dez) agendas por subconta (adicional disponível)</li>
        <li>Plataforma de gestão completa</li>
        <li>Chat estilo WhatsApp Web</li>
        <li>Playground de testes</li>
        <li>Tags ilimitadas</li>
        <li>Suporte prioritário via WhatsApp</li>
      </ul>

      <p><b>1.3.3. PLANOS LEGADOS</b></p>
      <p>
        Os planos a seguir não são mais oferecidos a novos CONTRATANTES,
        permanecendo vigentes exclusivamente para aqueles que os contrataram
        anteriormente à sua descontinuação: Plano Gratuito (pessoal),
        Plano OnDemand (comercial), Plano PRO (comercial), Plano Business
        (comercial com White Label incluso) e Plano Founder (comercial).
      </p>
      <p>
        Os CONTRATANTES em planos legados mantêm suas condições originais até
        que optem voluntariamente por migrar para um dos planos ativos descritos
        nas cláusulas 1.3.1 e 1.3.2, observado o disposto na cláusula 8.1.1.
      </p>

      <p>
        1.3.4. Os recursos indicados como "adicional disponível" poderão ser
        contratados mediante pagamento de valor complementar, conforme tabela
        de preços vigente descrita na cláusula 1.4. Planos de uso pessoal
        (Starter e Business Pessoal) não possuem módulo de addons, sendo
        os recursos adicionais exclusivos dos planos White Label.
      </p>
      <p>
        1.3.5. <b>Somente o pagamento do valor integral do plano</b>, conforme tabela
        de preços vigente, garantirá ao CONTRATANTE acesso à totalidade dos recursos
        previstos para o respectivo plano. Ofertas promocionais poderão contemplar
        condições diferenciadas, inclusive quantidade reduzida de recursos (subcontas,
        usuários, mensagens, etc.) em relação ao plano padrão, conforme cláusula 3.
      </p>
      <p>
        1.4. <b>Tabela de Recursos Adicionais (Addons)</b> — disponíveis exclusivamente
        para os planos White Label, White Label Plus e White Label Pro, contratáveis
        de forma mensal recorrente, conforme valores abaixo:
      </p>
      <ul>
        <li>Usuário adicional: R$ 40,00/mês por usuário</li>
        <li>Instância WhatsApp adicional: R$ 30,00/mês por instância</li>
        <li>Agenda adicional: R$ 30,00/mês por agenda</li>
        <li>2.000 (duas mil) clientes adicionais: R$ 50,00/mês</li>
        <li>2.000 (duas mil) contatos adicionais no Pipeline CRM: R$ 50,00/mês</li>
        <li>Subconta adicional: R$ 150,00/mês por subconta</li>
        <li>
          Publicação de agente adicional (com instância WhatsApp inclusa):
          R$ 150,00/mês por agente publicado
        </li>
      </ul>
      <p>1.4.1. <b>Pacotes de mensagens adicionais — API não oficial:</b></p>
      <ul>
        <li>
          Pacote de 3.000 (três mil) mensagens adicionais por mês: R$ 75,00/mês —
          aplicável <b>exclusivamente</b> à conexão via API não oficial do WhatsApp.
        </li>
      </ul>
      <p>
        1.4.2. <b>API Oficial do WhatsApp (WhatsApp Business Platform):</b> a
        integração com a API oficial do WhatsApp possuirá tarifação própria,
        cobrada por conversa iniciada conforme as categorias e valores praticados
        pela Meta Platforms, Inc., que serão repassados ao CONTRATANTE sem pacote
        pré-definido de mensagens. Os valores praticados serão informados
        previamente no momento da ativação da integração com a API oficial.
      </p>
      <p>
        1.4.3. Todos os valores de addons são mensais recorrentes, sendo
        cobrados em conjunto com a mensalidade do plano contratado. O
        cancelamento de um addon poderá ser solicitado a qualquer momento
        pelo CONTRATANTE e surtirá efeito no próximo ciclo de faturamento.
      </p>
      <p>
        1.4.4. Os serviços descritos neste instrumento poderão ter suas
        condições, funcionalidades e parâmetros comerciais ajustados a qualquer
        tempo, a exclusivo critério da CONTRATADA, mediante prévio aviso e
        justificativa, observado o disposto na cláusula 5.5.
      </p>
      <p>
        1.5. Para efetuar a contratação dos serviços, o CONTRATANTE deverá
        preencher um cadastro eletrônico, no qual o CONTRATANTE, além dos dados
        cadastrais, irá escolher o Plano a ser contratado.
      </p>
      <p>
        1.5.1. Todas as informações constantes do cadastro eletrônico fazem
        parte do presente Termo para todos os fins.
      </p>
      <p>
        1.6. Natureza dos Serviços: A conta Mercado Agentes licencia seu
        software ao CONTRATANTE, que, por sua vez, utilizará a plataforma como
        um meio instrumental para prover serviços a seus próprios clientes
        finais. A CONTRATADA, neste contexto, limita-se a fornecer a
        infraestrutura tecnológica necessária, isentando-se de qualquer
        responsabilidade ou vínculo jurídico direto com os consumidores do
        CONTRATANTE.
      </p>
      <p>
        1.7. As partes reconhecem que o presente instrumento é celebrado em
        ambiente empresarial (B2B), não se aplicando o Código de Defesa do
        Consumidor, salvo se comprovado que o CONTRATANTE é destinatário final.
      </p>
      <p>
        1.8. A prestação dos serviços constitui obrigação de meio e não de
        resultado, não havendo qualquer garantia de performance comercial,
        disponibilidade contínua, técnica ou econômica para o CONTRATANTE ou
        seus clientes, tampouco se responsabilizando por decisões ou atos do
        CONTRATANTE ou de seus clientes baseados em informações processadas pela
        plataforma.
      </p>
      <p>
        1.9. <b>Modalidades de uso:</b> os planos são categorizados em duas
        modalidades distintas:
      </p>
      <p>
        a) <b>USO PESSOAL:</b> destinado a pessoas físicas ou jurídicas que
        utilizarão a plataforma para operação própria, sem criação de subcontas
        e sem marca personalizada. Compreende os planos Starter e Business
        descritos na cláusula 1.3.1.
      </p>
      <p>
        b) <b>USO COMERCIAL (White Label):</b> destinado a CONTRATANTES que
        desejam oferecer a plataforma como marca própria aos seus clientes
        finais mediante criação de subcontas. Compreende os planos White Label,
        White Label Plus e White Label Pro descritos na cláusula 1.3.2.
      </p>
      <p>
        1.9.1. A alteração entre modalidades (pessoal ↔ comercial) não é
        realizada por upgrade direto. O CONTRATANTE que desejar migrar entre
        modalidades deverá contratar novo plano na modalidade desejada,
        observado o disposto na cláusula 8.1.1.
      </p>

      <p>
        1.10. <b>Definições aplicáveis a este instrumento:</b> para fins de
        interpretação e aplicação das cláusulas deste contrato, especialmente
        quanto à modalidade White Label, considera-se:
      </p>
      <p>
        a) <b>Cliente Final:</b> pessoa física ou jurídica que utiliza os
        agentes de IA criados pelo CONTRATANTE para uso próprio (caso PF) ou
        para automação, atendimento ou operação interna do seu próprio negócio
        (caso PJ), no relacionamento com seus respectivos consumidores, clientes
        ou colaboradores.
      </p>
      <p>
        b) <b>Operação Própria:</b> o uso dos agentes de IA pelo Cliente Final
        como ferramenta de apoio ao seu negócio, sem que o Cliente Final ofereça,
        comercialize, sublicencie ou permita a terceiros a criação de novos
        agentes de IA por meio de sua subconta.
      </p>
      <p>
        c) <b>Subconta Autorizada:</b> ambiente segregado dentro da plataforma,
        criado pelo CONTRATANTE em favor de um único Cliente Final, vinculado
        ao CNPJ ou CPF deste, no qual o Cliente Final não detém poder
        administrativo para criar novas subcontas, gerenciar terceiros não
        vinculados ao seu próprio quadro funcional, ou comercializar acesso ao
        ambiente.
      </p>
      <p>
        d) <b>Sublicenciamento Vedado:</b> qualquer modalidade pela qual o
        CONTRATANTE, direta ou indiretamente, permita que um Cliente Final, ou
        terceiro com acesso à subconta, ofereça a plataforma ou suas
        funcionalidades de criação de agentes de IA a outros usuários, com ou
        sem contraprestação, configurando cadeia de revenda do serviço.
      </p>

      {/* CLÁUSULA 2 - RESTRIÇÕES DE USO */}
      <h5><u>2. Restrições de Uso e Finalidade Exclusiva</u></h5>
      <p>2.1. Fica <b>expressamente VEDADO</b> ao CONTRATANTE:</p>
      <p>
        a) Sublicenciar, revender, redistribuir ou comercializar a plataforma
        MercadoAgentes ou quaisquer de suas funcionalidades para terceiros, sob
        qualquer modalidade, sem autorização prévia e expressa por escrito da CONTRATADA;
      </p>
      <p>
        b) Utilizar a plataforma para criar estrutura de revenda multinível ou
        franquias digitais sem autorização expressa e por escrito da CONTRATADA;
      </p>
      <p>
        c) Ceder, transferir ou compartilhar credenciais de acesso com terceiros
        não vinculados à operação do CONTRATANTE;
      </p>
      <p>
        d) Utilizar a plataforma para fins diversos daqueles expressamente
        previstos neste instrumento;
      </p>
      <p>
        e) Desenvolver, criar ou comercializar plataforma similar ou concorrente
        que utilize conceitos, metodologias ou funcionalidades substancialmente
        similares às da plataforma MercadoAgentes.
      </p>
      <p>2.2. A violação das vedações previstas nesta cláusula ensejará:</p>
      <p>a) Rescisão imediata do contrato, sem direito a reembolso de valores já pagos;</p>
      <p>
        b) Multa compensatória aplicada na seguinte gradação, conforme a
        natureza da violação:
      </p>
      <p>
        i) Violações formais ou de menor potencial ofensivo (ex.: cessão pontual
        de credenciais sem comprovação de prejuízo): 6 (seis) vezes o valor da
        última mensalidade paga;
      </p>
      <p>
        ii) Violações ao modelo de uso autorizado (ex.: estruturação de revenda
        vedada, conforme cláusulas 4.3 e 4.4-A): 12 (doze) vezes o valor da
        última mensalidade paga;
      </p>
      <p>
        iii) Violações de propriedade intelectual ou desenvolvimento de
        plataforma concorrente (cláusulas 17.2 e 18): 24 (vinte e quatro) vezes
        o valor da última mensalidade paga, considerando a maior mensalidade
        praticada nos 12 (doze) meses anteriores.
      </p>
      <p>
        Em qualquer hipótese, a multa não exclui o direito de cobrança de perdas
        e danos efetivamente comprovados que excedam seu valor.
      </p>
      <p>
        c) Responsabilização civil e criminal, conforme legislação aplicável,
        especialmente Lei nº 9.609/98 (Lei de Software) e Lei nº 9.610/98 (Lei
        de Direitos Autorais).
      </p>

      {/* CLÁUSULA 3 - OFERTAS PROMOCIONAIS */}
      <h5><u>3. Ofertas Promocionais e Condições Especiais</u></h5>
      <p>
        3.1. A CONTRATADA poderá, a seu exclusivo critério, disponibilizar
        ofertas promocionais, descontos temporários ou condições especiais de
        contratação, que constituirão exceções às condições regulares dos planos.
      </p>
      <p>
        3.2. As ofertas promocionais poderão contemplar condições diferenciadas,
        inclusive quantidade reduzida de recursos (subcontas, usuários,
        mensagens, etc.) em relação ao plano padrão, sendo que tais condições
        estarão expressamente descritas nos materiais da oferta.
      </p>
      <p>3.3. As ofertas promocionais:</p>
      <p>
        a) Possuem prazo de validade determinado, após o qual o CONTRATANTE
        passará a ser cobrado pelo valor regular do plano contratado;
      </p>
      <p>
        b) Poderão ser removidas, alteradas ou descontinuadas a qualquer momento
        pela CONTRATADA, por se tratar de condições temporárias e excepcionais,
        mediante comunicação prévia de 15 (quinze) dias aos contratantes ativos;
      </p>
      <p>
        c) Não geram direito adquirido à manutenção das condições promocionais
        após o término do período estipulado;
      </p>
      <p>d) São intransferíveis e pessoais, não podendo ser cedidas a terceiros.</p>
      <p>
        3.4. A remoção de ofertas promocionais se justifica pela natureza
        temporária e excepcional de tais condições, bem como pela necessidade de
        adequação às estratégias comerciais da CONTRATADA, não configurando
        alteração unilateral prejudicial ao CONTRATANTE, desde que respeitado o
        período originalmente contratado.
      </p>

      {/* CLÁUSULA 4 - WHITE LABEL */}
      <h5><u>4. Licenciamento White Label</u></h5>
      <p>
        4.1. O CONTRATANTE que optar pelo plano com funcionalidade White Label
        terá direito a personalizar a interface da plataforma com sua própria
        identidade visual (logotipo, cores, nome comercial) e subdomínio próprio.
      </p>
      <p>
        4.2. A funcionalidade White Label permite ao CONTRATANTE oferecer a
        plataforma aos seus clientes finais como se fosse de sua titularidade,
        exclusivamente para fins de comercialização de agentes de inteligência
        artificial para uso próprio do cliente final (pessoa física ou jurídica),
        conforme Definições constantes da cláusula 1.10.
      </p>
      <p>
        4.3. Na modalidade White Label, são consideradas violações graves do
        contrato, ensejando rescisão imediata e aplicação das penalidades
        previstas na cláusula 2.2:
      </p>
      <p>
        a) Permitir que Cliente Final crie ou gerencie novas subcontas, exceto
        aquelas estritamente vinculadas a seu próprio quadro de colaboradores ou
        unidades de seu mesmo CNPJ;
      </p>
      <p>
        b) Comercializar, ceder, sublicenciar ou disponibilizar a Cliente Final
        a funcionalidade de criação ilimitada de agentes de IA destinados a
        terceiros não vinculados à sua operação interna;
      </p>
      <p>
        c) Estruturar modelo de negócio no qual o Cliente Final figure como
        intermediário entre o CONTRATANTE e os usuários efetivos dos agentes de IA;
      </p>
      <p>
        d) Permitir que mais de um CNPJ distinto opere sob a mesma subconta,
        ressalvado o caso de grupo econômico devidamente comprovado e previamente
        comunicado à CONTRATADA;
      </p>
      <p>e) Revender, sublicenciar ou transferir a plataforma como produto SaaS autônomo;</p>
      <p>f) Criar estrutura de parceiros, afiliados ou franqueados que comercializem a plataforma;</p>
      <p>g) Utilizar a plataforma para desenvolvimento de software concorrente ou engenharia reversa;</p>
      <p>
        h) Remover quaisquer referências à titularidade da CONTRATADA que não
        sejam parte da interface personalizável.
      </p>
      <p>
        4.4. O cliente final do CONTRATANTE White Label deverá utilizar os
        agentes de IA exclusivamente para uso próprio (pessoa física) ou
        operacional de seu negócio (pessoa jurídica), sendo vedada qualquer
        modalidade de revenda ou sublicenciamento por parte do cliente final.
      </p>
      <p>
        4.4-A. <b>Presunção de violação ao modelo de uso autorizado:</b>
        presume-se, salvo prova em contrário a ser fornecida pelo CONTRATANTE em
        até 10 (dez) dias úteis após notificação formal, configurada a violação
        ao modelo de uso autorizado quando:
      </p>
      <p>
        a) Uma mesma subconta apresentar volume de mensagens, contatos ou
        atendimentos incompatível com a operação de uma única empresa do porte
        declarado no cadastro;
      </p>
      <p>
        b) Uma mesma subconta integrar mais de 3 (três) instâncias de WhatsApp
        vinculadas a CNPJs distintos;
      </p>
      <p>
        c) Os agentes de IA de uma subconta forem configurados para atender a
        mais de uma marca, identidade visual ou empresa não pertencente ao mesmo
        grupo econômico;
      </p>
      <p>
        d) Houver indícios técnicos de que o Cliente Final esteja revendendo
        acesso a terceiros, tais como cobranças recorrentes recebidas pelo
        Cliente Final relacionadas ao acesso à subconta.
      </p>
      <p>
        4.4-B. A presunção estabelecida na cláusula 4.4-A inverte o ônus
        probatório, cabendo ao CONTRATANTE demonstrar a regularidade da operação
        mediante apresentação de documentação societária, contratos de prestação
        de serviços com seus Clientes Finais e demais elementos pertinentes.
      </p>
      <p>
        4.5. O CONTRATANTE White Label assume integral responsabilidade perante
        seus clientes finais, inclusive quanto ao suporte, atendimento e
        cumprimento de obrigações legais, isentando a CONTRATADA de qualquer
        responsabilidade direta com tais usuários.
      </p>
      <p>
        4.6. <b>Níveis de White Label:</b> a funcionalidade White Label é
        disponibilizada em três níveis, com diferenças quanto à quantidade de
        subcontas, usuários, limites de recursos e nível de suporte, conforme
        detalhado na cláusula 1.3.2:
      </p>
      <p>a) White Label — nível de entrada, indicado para início de operação;</p>
      <p>
        b) White Label Plus — nível intermediário, com maior capacidade de
        subcontas e recursos por subconta;
      </p>
      <p>
        c) White Label Pro — nível premium, com maior capacidade de subcontas,
        suporte prioritário via WhatsApp e 1 (uma) hora de consultoria mensal inclusa.
      </p>
      <p>
        4.6.1. A ativação da versão White Label ocorre exclusivamente após a
        confirmação do pagamento integral do plano. Durante o período de teste
        gratuito previsto na cláusula 8.5, os recursos de personalização de marca
        e domínio próprio permanecem indisponíveis, sendo liberados apenas após a
        primeira mensalidade ser devidamente quitada.
      </p>
      <p>
        4.7. <b>Consultoria inclusa no plano White Label Pro:</b> o CONTRATANTE
        do plano White Label Pro tem direito a 1 (uma) hora de consultoria mensal
        com a equipe da CONTRATADA, a ser agendada previamente pelo canal oficial
        de suporte.
      </p>
      <p>
        4.7.1. A hora de consultoria não utilizada no mês de competência não é
        cumulativa e não gera direito a reembolso, abatimento em mensalidades
        futuras ou conversão em quaisquer outros serviços, em conformidade com o
        princípio geral previsto na cláusula 6.4.
      </p>
      <p>
        4.7.2. A consultoria destina-se a esclarecimento de dúvidas, orientações
        estratégicas de uso da plataforma e auxílio em configurações avançadas,
        não incluindo desenvolvimento sob demanda, customizações específicas de
        código ou integrações personalizadas, que dependerão de contratação em apartado.
      </p>

      {/* CLÁUSULA 5 - COMO USAR */}
      <h5><u>5. Como usar nossos Serviços</u></h5>
      <p>
        5.1. O CONTRATANTE pode usar nossos serviços somente conforme permitido
        por lei, inclusive regulamentos. A CONTRATADA pode suspender ou deixar de
        fornecer os serviços se o CONTRATANTE descumprir os termos ou políticas
        ou em casos de suspeita de má conduta.
      </p>
      <p>
        5.2. O uso dos serviços da CONTRATADA não confere ao CONTRATANTE
        propriedade sobre direitos de propriedade intelectual, sobre os nossos
        serviços ou sobre o conteúdo que o CONTRATANTE acessar. O CONTRATANTE não
        pode usar conteúdos da CONTRATADA a menos que obtenha permissão do
        proprietário de tais conteúdos ou que o faça por algum meio permitido por
        lei. Estes termos não conferem ao CONTRATANTE o direito de usar quaisquer
        marcas ou logotipos utilizados em nossos Serviços, sem autorização prévia.
        Não remova, oculte ou altere quaisquer avisos legais exibidos em ou junto
        a nossos Serviços com auxílio de programadores.
      </p>
      <p>
        5.3. Os Serviços da CONTRATADA podem exibir alguns conteúdos que não são
        de propriedade da CONTRATADA. Esses conteúdos são de exclusiva
        responsabilidade da entidade que os disponibiliza. Podemos revisar
        conteúdo para determinar se é ilegal ou se infringe nossas políticas, e
        podemos remover ou nos recusar a exibir conteúdos que razoavelmente
        acreditamos violar nossas políticas ou a lei.
      </p>
      <p>
        5.4. Em relação com seu uso dos Serviços, podemos enviar-lhe anúncios de
        serviços, mensagens administrativas e outras informações. O CONTRATANTE
        pode desativar uma parte dessas comunicações.
      </p>
      <p>
        5.5. O CONTRATANTE reconhece que quaisquer alterações substanciais em
        funcionalidades essenciais ou valores de planos serão comunicadas com
        antecedência mínima de 30 (trinta) dias, podendo rescindir o contrato
        sem multa caso não concorde com as alterações.
      </p>

      {/* CLÁUSULA 6 - LIMITAÇÃO DE CONSUMO */}
      <h5><u>6. Limitação de Consumo e Excedentes</u></h5>
      <p>
        6.1. Os limites de utilização definidos para cada plano (mensagens,
        contatos, usuários, etc.) referem-se ao período mensal de faturamento.
      </p>
      <p>
        6.2. Atingido 80% (oitenta por cento) do limite de qualquer recurso, o
        CONTRATANTE será notificado automaticamente pela plataforma.
      </p>
      <p>6.3. Atingido 100% (cem por cento) do limite:</p>
      <p>
        a) O recurso poderá ser temporariamente suspenso até a contratação de
        pacote adicional ou início do próximo ciclo de faturamento;
      </p>
      <p>
        b) Alternativamente, a CONTRATADA poderá permitir a continuidade do uso
        mediante cobrança automática de pacote adicional, conforme tabela vigente;
      </p>
      <p>
        c) O CONTRATANTE será notificado previamente sobre qual modalidade de
        tratamento de excedentes será aplicada.
      </p>
      <p>
        6.4. Os recursos não utilizados no período mensal não são cumulativos e
        não poderão ser transferidos para períodos subsequentes.
      </p>

      {/* CLÁUSULA 7 - CONTA */}
      <h5><u>7. Sua Conta MercadoAgentes</u></h5>
      <p>
        7.1. Processo de Cadastro: ao se cadastrar, o CONTRATANTE deverá informar
        os seguintes dados: CPF/CNPJ, nome completo/razão social, e-mail,
        telefone, nome completo do responsável pela contratação, respectivo CPF e
        e-mail.
      </p>
      <p>
        7.1.1. Ao finalizar a contratação, serão emitidas as cobranças dos
        serviços escolhidos e o CONTRATANTE deverá escolher o meio de pagamento.
        Caso escolha a modalidade "cartão de crédito", serão solicitados os dados
        de seu cartão para finalizar o pagamento.
      </p>
      <p>
        7.2. O CONTRATANTE é responsável por manter sempre atualizado seu
        cadastro empresarial junto à CONTRATADA pelo seu Painel Financeiro dentro
        do Sistema, bem como pelos demais canais de comunicação da CONTRATADA,
        comunicando, imediatamente, sempre que houver quaisquer alterações em seus
        dados, incluindo, mas não se limitando a endereço, telefone e e-mail para
        contato.
      </p>
      <p>
        7.3. Os dados fornecidos pelo CONTRATANTE serão submetidos à previsão da
        cláusula 20 – Da Lei Geral de Proteção de Dados (LGPD).
      </p>
      <p>
        7.4. O CONTRATANTE é responsável por todos os atos praticados mediante o
        uso das credenciais de acesso de todos os usuários vinculados à sua conta.
      </p>
      <p>
        7.4.1. Para proteger sua conta MercadoAgentes, o CONTRATANTE deve manter
        a senha em sigilo. A atividade realizada na Conta do MercadoAgentes ou
        por seu intermédio é de responsabilidade do CONTRATANTE.
      </p>
      <p>
        7.4.2. Caso tome conhecimento de uso não autorizado da sua senha ou Conta
        da MercadoAgentes, o CONTRATANTE deve entrar em contato com o suporte da
        MercadoAgentes enviando um e-mail para contato@mercadoagentes.com,
        informando o problema.
      </p>

      {/* CLÁUSULA 8 - ALTERAÇÕES E CANCELAMENTO */}
      <h5><u>8. Alterações de Plano e Cancelamento</u></h5>
      <p>
        8.1. Para alteração de Plano, o CONTRATANTE poderá efetuar alteração a
        qualquer momento, a confirmação da alteração se dará a partir da
        identificação do pagamento da cobrança, sendo que o CONTRATANTE será
        cobrado o valor integral do novo plano escolhido.
      </p>
      <p>
        8.1.1. Fica expressamente vedada ao CONTRATANTE a possibilidade de
        realizar downgrade de plano dentro da mesma modalidade de uso (pessoal ou
        comercial) durante o período vigente, entendendo-se por downgrade a
        migração para plano de valor ou recursos inferiores à originalmente
        pactuada. Qualquer alteração contratual dentro da mesma modalidade
        somente poderá ocorrer mediante solicitação de upgrade, observadas as
        condições comerciais então vigentes.
      </p>
      <p>
        8.1.2. A vedação ao downgrade de plano prevista neste instrumento
        justifica-se em razão da arquitetura técnica da plataforma e dos custos
        de manutenção, sendo possível a contratação de novo plano de menor valor
        após o término do período vigente.
      </p>
      <p>
        8.1.3. Migração entre modalidades (pessoal ↔ comercial): a alteração da
        modalidade de uso não é considerada upgrade nem downgrade, e sim
        contratação de novo plano. Para migrar entre modalidades, o CONTRATANTE
        deverá:
      </p>
      <p>
        a) Aguardar o término do ciclo de faturamento do plano vigente, sem
        direito a reembolso proporcional; e
      </p>
      <p>
        b) Contratar novo plano na modalidade desejada, observadas as condições
        comerciais vigentes à época da nova contratação.
      </p>
      <p>
        8.1.4. Os planos legados (cláusula 1.3.3) seguem a mesma regra: o
        CONTRATANTE em plano legado pode migrar para qualquer plano ativo da mesma
        modalidade via upgrade, ou para modalidade distinta mediante nova
        contratação, não sendo possível retornar a plano legado após a migração.
      </p>
      <p>
        8.2. O cancelamento do plano poderá ser solicitado a qualquer momento
        pelo CONTRATANTE, mediante comunicação formal enviada à CONTRATADA. O
        cancelamento implica a imediata suspensão do acesso do CONTRATANTE e de
        seus respectivos clientes finais aos serviços da plataforma, sem qualquer
        obrigação de reembolso de valores já pagos.
      </p>
      <p>
        8.3. <b>Retenção e eliminação de dados após o cancelamento.</b> Cancelado
        o contrato, a CONTRATADA disponibilizará ao CONTRATANTE, pelo prazo de
        30 (trinta) dias, a possibilidade de exportação de seus dados operacionais
        (diversos módulos da plataforma já oferecem exportação nativa). Quanto à
        guarda subsequente:
      </p>
      <p>
        a) <b>Dados operacionais</b> (mensagens, contatos, configurações de
        agentes e dados de Clientes Finais): serão mantidos por até 12 (doze)
        meses, exclusivamente para permitir eventual reativação da conta, a
        critério do CONTRATANTE, que poderá a qualquer momento solicitar a sua
        eliminação imediata. Decorrido o prazo sem reativação, os dados serão
        definitivamente eliminados;
      </p>
      <p>
        b) <b>Documentos contratuais e fiscais</b> (contratos, notas fiscais,
        comprovantes de pagamento e registros de incidentes de segurança): serão
        mantidos pelos prazos exigidos pela legislação fiscal aplicável e pela
        Resolução CD/ANPD nº 15/2024 (registro de incidentes por, no mínimo, 5
        anos), com fundamento no art. 7º, II, e no art. 16, I, da Lei nº
        13.709/2018.
      </p>
      <p>
        Configurações proprietárias da plataforma (arquitetura, código, fluxos
        internos) não são objeto de portabilidade, dada a sua natureza de
        propriedade intelectual exclusiva da CONTRATADA.
      </p>
      <p>
        8.4. As operações de Alteração de Plano e Cancelamento somente serão
        efetuadas através do CONTRATANTE, mediante o uso de suas credenciais de
        acesso e envio de e-mail para contato@mercadoagentes.com formalizando a
        solicitação.
      </p>
      <p><b>8.5. Período de Teste Gratuito de 7 (sete) Dias:</b></p>
      <p>
        8.5.1. Todo novo CONTRATANTE tem direito a 7 (sete) dias corridos de uso
        gratuito da plataforma, contados a partir da data de ativação da conta,
        independentemente do plano escolhido no momento do cadastro. Durante o
        período de teste:
      </p>
      <p>
        a) NÃO é solicitado cadastro de cartão de crédito ou qualquer outro meio
        de pagamento no momento do cadastro;
      </p>
      <p>b) Não há qualquer cobrança, débito ou autorização de cobrança prévia;</p>
      <p>
        c) O CONTRATANTE tem acesso aos recursos do plano escolhido, com exceção
        da ativação da marca personalizada (White Label), que somente é liberada
        após o pagamento do plano, conforme cláusula 4.6.1.
      </p>
      <p>
        8.5.2. Não há cobrança automática ao final do período de teste. Pelo fato
        de não haver meio de pagamento cadastrado, o CONTRATANTE não será cobrado
        e não precisa solicitar cancelamento para encerrar o teste — o plano
        expira automaticamente no 7º dia.
      </p>
      <p>
        8.5.3. Findo o período de 7 (sete) dias sem que o CONTRATANTE tenha
        contratado um plano pago, o acesso à plataforma será suspenso
        automaticamente, permanecendo os dados da conta armazenados em ambiente
        seguro pelo prazo previsto na cláusula 8.3 para eventual reativação
        mediante contratação de plano pago.
      </p>
      <p>
        8.5.4. Caso o CONTRATANTE deseje continuar utilizando a plataforma após o
        período de teste, deverá contratar um dos planos descritos na cláusula
        1.3 dentro do prazo de 7 (sete) dias, mediante o cadastro de meio de
        pagamento e quitação da primeira mensalidade.
      </p>
      <p>
        8.5.5. O direito de arrependimento de 7 (sete) dias previsto no artigo 49
        do Código de Defesa do Consumidor (CDC) fica integralmente atendido pelo
        período de teste gratuito acima, quando aplicável à relação de consumo,
        considerando que não há cobrança prévia ao CONTRATANTE.
      </p>

      {/* CLÁUSULA 9 - PRIVACIDADE E DIREITOS AUTORAIS */}
      <h5><u>9. Proteção à Privacidade e aos Direitos Autorais</u></h5>
      <p>
        9.1. O conteúdo enviado pelo CONTRATANTE e por seus Clientes Finais à
        plataforma (incluindo mensagens, contatos, configurações, prompts e bases
        de conhecimento) permanece de titularidade do CONTRATANTE ou de quem de
        direito, não implicando este instrumento qualquer transferência de
        titularidade de direitos autorais ou de propriedade intelectual. O
        CONTRATANTE concede à CONTRATADA licença <b>não exclusiva, limitada e
        revogável</b>, restrita ao tempo e à medida necessários para operar,
        hospedar, armazenar e processar tal conteúdo, com a finalidade única de
        prestar os serviços contratados, segundo as instruções do CONTRATANTE e
        nos termos da cláusula 20. O CONTRATANTE declara possuir os direitos
        necessários para conceder tal licença sobre o conteúdo que enviar.
      </p>
      <p>
        9.1.1. A CONTRATADA <b>não utiliza</b> o conteúdo ou as mensagens do
        CONTRATANTE ou de seus Clientes Finais para treinar, ajustar ou aprimorar
        modelos de inteligência artificial, próprios ou de terceiros, nem para
        finalidades publicitárias ou de desenvolvimento de novos produtos. Os
        modelos de linguagem (LLMs) de terceiros são acessados exclusivamente via
        API para a geração de respostas dos agentes, sem que o conteúdo seja
        utilizado para treinamento desses modelos. A CONTRATADA poderá tratar
        apenas <b>dados estatísticos agregados e anonimizados</b> de uso da
        plataforma, que não permitam a reidentificação de titulares, para fins de
        melhoria técnica dos serviços, nos termos do art. 12 da Lei nº 13.709/2018.
      </p>
      <p>
        9.1.2. A licença prevista nesta cláusula extingue-se com o término do
        contrato, ressalvados os prazos de guarda previstos na cláusula 8.3 e na
        legislação aplicável, não subsistindo qualquer direito de uso pela
        CONTRATADA após a eliminação dos dados.
      </p>
      <p>
        9.2. Caso o CONTRATANTE possua uma Conta do MercadoAgentes, a CONTRATADA
        poderá exibir o nome comercial e o logotipo do CONTRATANTE em sua vitrine
        de clientes (site institucional e materiais de marketing), com fundamento
        em legítimo interesse (art. 7º, IX, da LGPD). O CONTRATANTE poderá, a
        qualquer tempo e sem ônus, solicitar a remoção dessa exibição pelo canal
        do Encarregado indicado na cláusula 20, hipótese em que a CONTRATADA
        atenderá em prazo razoável.
      </p>

      {/* CLÁUSULA 10 - SEU CONTEÚDO */}
      <h5><u>10. Seu Conteúdo em nossos Serviços</u></h5>
      <p>
        10.1. O MercadoAgentes concede ao CONTRATANTE uma licença pessoal,
        mundial, não exclusiva, intransferível e isenta de royalties para o uso do
        software fornecido pelo MercadoAgentes como parte dos Serviços. Essa
        licença tem como único objetivo permitir que o CONTRATANTE use e aproveite
        o benefício dos Serviços da forma permitida por estes termos. O
        CONTRATANTE não poderá copiar, modificar, distribuir, vender ou alugar
        qualquer parte de nossos Serviços ou o software incluso, nem poderá fazer
        engenharia reversa ou tentar extrair o código fonte desse software, exceto
        nos casos em que a legislação proibir tais restrições, ou quando o
        CONTRATANTE tiver nossa permissão por escrito.
      </p>

      {/* CLÁUSULA 11 - SOFTWARE */}
      <h5><u>11. Sobre Software em nossos Serviços</u></h5>
      <p>
        11.1. A CONTRATADA poderá descontinuar funcionalidades, módulos ou a
        totalidade dos serviços mediante aviso prévio de 30 (trinta) dias,
        comunicado por e-mail aos CONTRATANTES ativos. No caso de descontinuação
        substancial dos serviços, durante o período de aviso prévio, o CONTRATANTE
        poderá solicitar a exportação de seus dados operacionais, observado que
        diversos módulos da plataforma já dispõem nativamente de funcionalidade de
        exportação.
      </p>
      <p>
        11.2. O MercadoAgentes pode usar o armazenamento de informações (conhecido
        como cookies) para permitir que o CONTRATANTE use o nosso site mais
        facilmente e para que possamos manter o controle de determinados dados
        estatísticos que nos ajudam a melhorar os nossos serviços. A maioria dos
        navegadores é inicialmente configurado para aceitar cookies. Se desejar, o
        CONTRATANTE pode instruir o seu navegador de internet para impedir que os
        cookies sejam usados e apague os cookies existentes. No entanto, note que a
        alta qualidade dos nossos serviços pode ser reduzida como consequência do
        mesmo. Consulte o guia de ajuda de seu navegador de internet (browser)
        para obter mais orientações.
      </p>
      <p>
        11.3. O CONTRATANTE reconhece que, por se tratar de serviço online, não há
        garantia de nível mínimo de disponibilidade (SLA), salvo se pactuado em
        instrumento específico.
      </p>
      <p>
        11.3.1. Indisponibilidades decorrentes de fatores externos à
        infraestrutura sob controle direto da CONTRATADA, incluindo mas não se
        limitando a: (a) falhas em provedores de modelos de IA de terceiros
        (LLMs); (b) alterações ou indisponibilidades nas APIs do WhatsApp; (c)
        interrupções de serviços de cloud computing; (d) ataques cibernéticos; (e)
        caso fortuito ou força maior, não geram direito a abatimento de
        mensalidade, ressarcimento ou indenização, devendo ser absorvidas pelo
        CONTRATANTE em sua relação com seus Clientes Finais.
      </p>
      <p>
        11.3.2. O CONTRATANTE assume integral responsabilidade por orientar seus
        Clientes Finais quanto à natureza do serviço prestado e às hipóteses de
        indisponibilidade descritas nesta cláusula, isentando a CONTRATADA de
        qualquer reclamação direta por parte de tais Clientes Finais.
      </p>

      {/* CLÁUSULA 12 - IA */}
      <h5><u>12. Uso de Inteligência Artificial e Limitação de Responsabilidade</u></h5>
      <p>
        12.1. O CONTRATANTE reconhece que os agentes de inteligência artificial
        criados na plataforma utilizam modelos de linguagem de terceiros (LLMs),
        acessados exclusivamente via API, e que as respostas geradas são
        probabilísticas, podendo eventualmente conter imprecisões, informações
        desatualizadas ou conteúdo inadequado.
      </p>
      <p>12.2. A CONTRATADA não se responsabiliza por:</p>
      <p>
        a) Decisões tomadas pelo CONTRATANTE ou seus clientes com base em
        respostas fornecidas pelos agentes de IA;
      </p>
      <p>
        b) Conteúdo gerado pelos agentes de IA que viole direitos de terceiros,
        incluindo direitos autorais, marcas ou privacidade;
      </p>
      <p>
        c) Danos diretos, indiretos, incidentais ou consequenciais decorrentes do
        uso ou impossibilidade de uso dos agentes de IA;
      </p>
      <p>
        d) Alterações nas APIs ou modelos de IA de terceiros que afetem o
        funcionamento dos agentes;
      </p>
      <p>e) Indisponibilidade temporária dos serviços de IA fornecidos por terceiros.</p>
      <p>12.3. O CONTRATANTE é integralmente responsável por:</p>
      <p>a) Configurar, treinar e supervisionar os agentes de IA criados em sua conta;</p>
      <p>
        b) Verificar a adequação das respostas dos agentes antes de
        disponibilizá-los aos clientes finais;
      </p>
      <p>c) Informar seus clientes finais sobre a natureza automatizada do atendimento;</p>
      <p>
        d) Cumprir toda legislação aplicável, incluindo normas de proteção ao
        consumidor, regulamentações específicas sobre IA e Marco Civil da Internet.
      </p>

      {/* CLÁUSULA 13 - RENOVAÇÃO */}
      <h5><u>13. Como renovar, modificar e cancelar nossos Serviços</u></h5>
      <p>
        13.1. O MercadoAgentes se reserva ao direito de rescindir a sua conta e
        impedir o seu acesso a qualquer tempo, caso seja constatada qualquer
        violação aos Termos de Uso. Caso ocorra a possibilidade acima descrita,
        nenhuma taxa ou despesa será reembolsável, a não ser em casos específicos
        em que houve uma garantia associada à contratação, a ser validada via
        e-mail por preposto ou sócio do MercadoAgentes.
      </p>
      <p>
        13.2. Os valores praticados poderão ser reajustados pela CONTRATADA
        mediante comunicação prévia de 30 (trinta) dias, aplicável ao ciclo mensal
        subsequente. O CONTRATANTE que não concordar com o reajuste poderá, sem
        qualquer ônus, deixar de renovar o serviço no ciclo de aplicação do novo
        valor, conforme procedimento previsto na cláusula 8.2. A renovação
        automática mês a mês mantém o mesmo formato de pagamento utilizado na
        primeira contratação.
      </p>
      <p>
        13.3. Para cancelamento ou modificação de sua assinatura, o CONTRATANTE
        deverá fazer sua solicitação por meio do e-mail contato@mercadoagentes.com.
      </p>
      <p>
        13.3.1. Quando houver cancelamento do plano mensal, não haverá
        possibilidade de cancelamento fracionado, sendo a cobrança sempre da
        mensalidade integral do mês vigente.
      </p>

      {/* CLÁUSULA 14 - GARANTIAS */}
      <h5><u>14. Nossas Garantias e Isenções de Responsabilidade</u></h5>
      <p>
        14.1. Quando permitido por lei, o MercadoAgentes e os fornecedores ou
        colaboradores do MercadoAgentes não serão responsáveis por perda de
        lucros, perda de receita, perda de dados, perdas financeiras ou danos
        indiretos, especiais, consequenciais, exemplares ou punitivos.
      </p>
      <p>
        14.1.1. Na medida permitida por lei, a responsabilidade total e agregada
        da CONTRATADA, seus fornecedores e colaboradores, por todas as reclamações
        decorrentes deste contrato, incluindo eventuais garantias implícitas, fica
        limitada, em conjunto, ao menor dos seguintes valores: (i) o valor
        efetivamente pago pelo CONTRATANTE à CONTRATADA nos 12 (doze) meses
        imediatamente anteriores ao evento que originou a reclamação; ou (ii) o
        equivalente a 3 (três) vezes a maior mensalidade do plano padrão vigente,
        excluídos quaisquer pagamentos efetuados a título de addons, mensagens
        excedentes ou serviços de consultoria.
      </p>
      <p>
        14.1.2. Em todos os casos, o MercadoAgentes e seus fornecedores e
        colaboradores não serão responsáveis por qualquer perda ou dano que não
        seja razoavelmente previsível.
      </p>
      <p>
        14.2. O MercadoAgentes adota medidas técnicas e organizacionais
        comercialmente razoáveis e compatíveis com os padrões usuais da indústria
        para proteger os dados, conforme detalhado na cláusula 20. Entretanto, o
        CONTRATANTE reconhece que nenhum sistema de segurança oferece total
        garantia, de forma que o MercadoAgentes não se responsabiliza por
        vazamento de dados quando comprovado que este tenha decorrido de ato
        criminoso de terceiros mediante o emprego de recursos tecnológicos
        superiores aos padrões usualmente aceitáveis pela indústria e utilizados
        pela CONTRATADA. Esta limitação opera entre as partes e não afasta
        eventuais obrigações legais da CONTRATADA perante a ANPD ou os titulares
        de dados, nos termos da legislação aplicável.
      </p>

      {/* CLÁUSULA 15 - RESPONSABILIDADE */}
      <h5><u>15. Responsabilidade pelos nossos Serviços</u></h5>
      <p>
        15.1. Se o CONTRATANTE estiver usando nossos Serviços em nome de uma
        empresa, tal empresa aceita estes termos. Ela isentará de responsabilidade
        e indenizará o MercadoAgentes e suas afiliadas, executivos e colaboradores
        de qualquer reivindicação, processo ou ação judicial proveniente de ou
        relacionado ao uso dos Serviços ou à violação destes termos, incluindo
        qualquer responsabilidade ou despesa resultante de reivindicações, perdas,
        danos, processos, julgamentos, custos de litígio e honorários advocatícios.
      </p>
      <p>
        15.2. O conteúdo de quaisquer websites que o CONTRATANTE acessar a partir
        dos Nossos Websites e software está totalmente fora do Nosso controle sendo
        que o acesso e a permanência em tais sites se darão por sua própria conta e
        risco. A inclusão destes links nos Websites e software não implica no nosso
        endosso ou anuência a quaisquer produtos, serviços, conteúdo, informação ou
        materiais oferecidos por, ou acessível ao CONTRATANTE nos websites de
        terceiros. Nós não representamos ou garantimos quaisquer websites de
        terceiros que o CONTRATANTE venha a acessar através dos Websites e software.
      </p>
      <p>
        15.3. Nós não podemos aceitar qualquer responsabilidade ou assumir
        qualquer obrigação com respeito a qualquer material contido em qualquer
        outro website. Quaisquer opiniões ou recomendações expressas nos referidos
        outros websites são unicamente aquelas dos provedores independentes e não
        são, tampouco representam, as opiniões ou recomendações do MercadoAgentes.
      </p>
      <p>
        15.4. O MercadoAgentes trabalha e envia os seus maiores esforços para
        manter os Websites e os Serviços em funcionamento, contudo, todos os
        serviços online estão sujeitos a interrupções e paradas ocasionais. O
        MercadoAgentes não se responsabiliza por nenhuma interrupção ou perda que o
        CONTRATANTE possa sofrer em decorrência de tais interrupções ou paradas.
      </p>

      {/* CLÁUSULA 16 - USOS COMERCIAIS */}
      <h5><u>16. Usos comerciais de nossos Serviços</u></h5>
      <p>
        16.1. Quaisquer melhorias ou adições aos Websites ou Serviços estarão
        sujeitos a estes Termos de Uso, a não ser que a CONTRATADA estabeleça
        expressamente de outra forma. Nós podemos introduzir novos conjuntos
        específicos de termos e condições para Serviços específicos, conforme
        apropriado, ou emendar termos e condições específicas existentes.
      </p>
      <p>
        16.2. O MercadoAgentes reserva-se o direito de modificar, suspender,
        terminar ou descontinuar qualquer aspecto do Website e software a qualquer
        tempo, incluindo a disponibilidade de quaisquer Serviços, informações,
        características ou funcionalidades acessíveis por meio dos Websites ou
        software. Nós também podemos impor limitações a certas características,
        funcionalidades ou serviços ou restringir seu acesso a partes ou à
        totalidade dos Websites e/ou dos Serviços sem prévia notificação e sem que
        isso implique em qualquer responsabilidade nossa por qualquer prejuízo que
        venha a sofrer.
      </p>
      <p>
        16.3. O MercadoAgentes reserva-se o direito de, a qualquer tempo ou
        título, controlar e/ou alterar a aparência, o desenvolvimento e/ou
        operações do Website e software a Nosso exclusivo critério, bem como
        estabelecer e modificar os procedimentos para o seu contato Conosco, sem a
        necessidade de notificação prévia.
      </p>
      <p>
        16.4. O CONTRATANTE não poderá ceder, sublicenciar, subcontratar,
        transferir ou dispor de quaisquer direitos e obrigações Seus no âmbito
        destes Termos de Uso sem o nosso consentimento prévio e por escrito.
      </p>

      {/* CLÁUSULA 17 - NÃO CONCORRÊNCIA */}
      <h5><u>17. Não Concorrência e Confidencialidade</u></h5>
      <p>
        17.1. O CONTRATANTE compromete-se a manter em sigilo todas as informações
        técnicas, comerciais e metodológicas a que tiver acesso durante a vigência
        deste contrato, incluindo, mas não se limitando a: arquitetura da
        plataforma, fluxos de automação, estratégias de precificação e materiais
        de treinamento.
      </p>
      <p>
        17.2. Durante a vigência do contrato e pelo período equivalente ao tempo
        total de vínculo contratual, limitado ao mínimo de 6 (seis) e ao máximo de
        12 (doze) meses após o término, o CONTRATANTE compromete-se a não, direta
        ou indiretamente, em território nacional brasileiro:
      </p>
      <p>
        a) Desenvolver, comercializar ou disponibilizar plataforma SaaS cuja
        proposta de valor central seja a criação, configuração e gestão de agentes
        de IA conversacional integrados a WhatsApp e CRM, em modelo White Label
        destinado a consultores ou empresas de tecnologia, ainda que mediante
        reconstrução autônoma de código, desde que utilize fluxos de configuração,
        taxonomias de agentes, estruturas de prompt, metodologias de onboarding ou
        arquitetura de subcontas substancialmente derivadas das observadas durante
        o uso da plataforma da CONTRATADA;
      </p>
      <p>
        b) Recrutar ou aliciar colaboradores, parceiros ou fornecedores da
        CONTRATADA que tenham mantido vínculo com a CONTRATADA nos 6 (seis) meses
        anteriores;
      </p>
      <p>c) Utilizar informações confidenciais para benefício próprio ou de terceiros.</p>
      <p>
        17.3. A violação desta cláusula sujeitará o CONTRATANTE ao pagamento de
        multa nos termos da gradação prevista na cláusula 2.2.b, item iii, sem
        prejuízo das perdas e danos apurados judicialmente.
      </p>

      {/* CLÁUSULA 18 - PROPRIEDADE INTELECTUAL */}
      <h5><u>18. Propriedade Intelectual sobre Agentes Criados</u></h5>
      <p>18.1. Os agentes de IA criados pelo CONTRATANTE na plataforma são compostos por:</p>
      <p>
        a) Infraestrutura tecnológica da plataforma - de propriedade exclusiva da
        CONTRATADA;
      </p>
      <p>
        b) Configurações, prompts e base de conhecimento inseridos pelo
        CONTRATANTE - de propriedade do CONTRATANTE.
      </p>
      <p>
        18.2. O CONTRATANTE mantém a titularidade sobre o conteúdo original por
        ele inserido (textos, imagens, documentos), podendo exportá-lo ao término
        do contrato, dentro do prazo estabelecido na cláusula 8.3.
      </p>
      <p>
        18.3. O CONTRATANTE não poderá replicar, fora da plataforma, a estrutura,
        fluxos de conversação ou metodologia de criação de agentes desenvolvida
        pela CONTRATADA.
      </p>
      <p>
        18.4. O CONTRATANTE reconhece que todo o código-fonte, design, marcas e
        elementos da plataforma são de titularidade exclusiva da CONTRATADA, sendo
        vedada sua reprodução, engenharia reversa ou uso para desenvolvimento de
        software concorrente.
      </p>

      {/* CLÁUSULA 19 - AUDITORIA */}
      <h5><u>19. Auditoria e Monitoramento</u></h5>
      <p>
        19.1. A CONTRATADA reserva-se o direito de monitorar o uso da plataforma
        para verificar o cumprimento destes Termos de Uso, incluindo análise de
        padrões de uso, volume de transações e conformidade com as vedações
        estabelecidas.
      </p>
      <p>19.2. Identificada qualquer irregularidade ou indício de violação, a CONTRATADA poderá:</p>
      <p>
        a) Solicitar esclarecimentos ao CONTRATANTE, que deverá responder em até
        48 (quarenta e oito) horas;
      </p>
      <p>b) Suspender temporariamente o acesso até regularização;</p>
      <p>c) Rescindir o contrato imediatamente em caso de violação grave ou reincidência.</p>
      <p>
        19.3. O CONTRATANTE reconhece e consente que, em razão da natureza
        hospedada da plataforma (Software as a Service), a CONTRATADA realiza, de
        forma automatizada, o monitoramento de <b>metadados operacionais</b> das
        subcontas — tais como volume de mensagens, número de instâncias, número de
        contatos e logs técnicos de uso — exclusivamente para fins de verificação
        de conformidade contratual e segurança da plataforma, com fundamento em
        legítimo interesse (art. 7º, IX, da Lei nº 13.709/2018), conforme avaliação
        de legítimo interesse mantida pela CONTRATADA. <b>Esse monitoramento não
        abrange o conteúdo das mensagens</b> trocadas nas subcontas.
      </p>
      <p>
        19.3.1. O acesso ao <b>conteúdo</b> de mensagens ou dados de uma subconta
        somente ocorrerá mediante solicitação ou autorização do CONTRATANTE, para
        fins de suporte técnico e resolução de problemas, hipótese em que a
        CONTRATADA atua na qualidade de Operadora, seguindo as instruções do
        CONTRATANTE e registrando o acesso.
      </p>
      <p>
        19.3.2. Identificada qualquer irregularidade ou indício de violação das
        cláusulas 4.3 e 4.4-A, a CONTRATADA poderá: (a) suspender preventivamente a
        subconta envolvida em até 24 (vinte e quatro) horas; (b) solicitar
        esclarecimentos ao CONTRATANTE, que deverá responder em até 10 (dez) dias
        úteis com documentação comprobatória da regularidade da operação; (c)
        rescindir o contrato em caso de não-resposta ou comprovação insuficiente.
      </p>

      {/* CLÁUSULA 20 - LGPD */}
      <h5><u>20. Da Lei Geral de Proteção de Dados (LGPD)</u></h5>
      <p>
        20.1. O tratamento de dados pessoais pela CONTRATADA fundamenta-se nas
        seguintes bases legais da Lei nº 13.709/2018, conforme a finalidade: (i)
        <b> execução de contrato</b> (art. 7º, V) para a prestação dos serviços;
        (ii) <b>cumprimento de obrigação legal ou regulatória</b> (art. 7º, II)
        para guarda fiscal e comunicação de incidentes; (iii) <b>legítimo
        interesse</b> (art. 7º, IX) para segurança, prevenção a fraudes, exercício
        regular de direitos e monitoramento de metadados de conformidade; e (iv)
        <b> consentimento</b> (art. 7º, I) apenas para finalidades que dele
        dependam, como comunicações de marketing, sempre revogável.
      </p>
      <p>
        20.1.1. Dados de identificação pessoal e cadastrais, a fim de que se
        garanta a fiel contratação pelo respectivo titular do contrato;
      </p>
      <p>
        20.1.2. Dados de contato e endereço do CONTRATANTE, tendo em vista a
        necessidade de envio de documentos, notificações e demais comunicações
        necessárias ao cumprimento do contrato;
      </p>
      <p>
        20.1.3. Os dados coletados poderão ser compartilhados com autoridades
        administrativas e judiciais, no âmbito de suas competências, em estrito
        cumprimento de dever legal, bem como com órgãos de proteção ao crédito a
        fim de resguardar a adimplência do CONTRATANTE perante a CONTRATADA, com
        fundamento em obrigação legal e legítimo interesse.
      </p>
      <p>
        20.2. As finalidades de tratamento são <b>específicas e determinadas</b>,
        descritas neste contrato, observando-se os princípios da finalidade,
        adequação e necessidade. A CONTRATADA coleta apenas os dados estritamente
        necessários aos fins almejados neste contrato.
      </p>
      <p>
        20.2.1. O CONTRATANTE autoriza o compartilhamento de seus dados, para os
        fins descritos nesta cláusula, com terceiros legalmente legítimos para
        defender os interesses da CONTRATADA bem como do CONTRATANTE.
      </p>
      <p>
        20.3. O CONTRATANTE pode, a qualquer tempo, solicitar acesso, correção,
        anonimização, portabilidade ou eliminação de seus dados pessoais, bem como
        informações sobre o tratamento, nos termos do art. 18 da Lei nº
        13.709/2018, pelo canal do Encarregado indicado na cláusula 20.13.
      </p>
      <p>
        20.3.1. A eliminação será atendida, ressalvada a guarda de documentos
        contratuais e fiscais pelos prazos legais aplicáveis (art. 16, I, da LGPD)
        e o registro de incidentes de segurança (Resolução CD/ANPD nº 15/2024). O
        CONTRATANTE reconhece que a eliminação de determinados dados pode
        inviabilizar a continuidade da prestação dos serviços.
      </p>
      <p>
        20.3.2. O CONTRATANTE autoriza a guarda dos documentos (contratos,
        documentos fiscais, notificações, protocolos e ordens de serviço) — ainda
        que contenham dados pessoais — pela CONTRATADA, para cumprimento de
        obrigação legal, nos termos do art. 16, inciso I, da Lei Geral de Proteção
        de Dados.
      </p>
      <p>
        20.4. <b>Comunicação de incidentes de segurança.</b> Na qualidade de
        Operadora, a CONTRATADA comunicará ao CONTRATANTE qualquer incidente de
        segurança envolvendo dados pessoais sem demora injustificada e, em qualquer
        caso, em até 24 (vinte e quatro) horas do conhecimento do incidente,
        fornecendo as informações necessárias para que o CONTRATANTE (Controlador)
        cumpra seu dever de comunicar a ANPD e os titulares no prazo previsto na
        Resolução CD/ANPD nº 15/2024.
      </p>
      <p>
        20.4.1. Na qualidade de Controladora (dados cadastrais do CONTRATANTE e
        metadados de monitoramento), a CONTRATADA comunicará a ANPD e os titulares
        afetados no prazo legal aplicável, quando o incidente puder acarretar risco
        ou dano relevante.
      </p>
      <p>
        20.4.2. A CONTRATADA manterá registro de todos os incidentes de segurança,
        comunicados ou não, pelo prazo mínimo de 5 (cinco) anos, nos termos da
        Resolução CD/ANPD nº 15/2024.
      </p>
      <p>
        20.5. A CONTRATADA mantém registro das operações de tratamento de dados
        pessoais e gerencia os dados por meio de sistemas que os coletam e tratam
        na forma da lei.
      </p>
      <p>
        20.6. Rescindido o contrato, os dados pessoais serão tratados conforme a
        cláusula 8.3. Decorridos os prazos de guarda pertinentes, a CONTRATADA
        realizará o descarte seguro dos dados.
      </p>
      <p>
        20.7. <b>Papéis das partes.</b> A CONTRATADA atua como Controladora quando
        define as finalidades e meios de tratamento (dados cadastrais do
        CONTRATANTE e metadados de monitoramento), e como Operadora quando trata
        dados em nome do CONTRATANTE para a execução dos serviços, seguindo suas
        instruções documentadas, comprometendo-se a auxiliá-lo no atendimento aos
        direitos dos titulares (art. 18 da LGPD).
      </p>
      <p>
        20.7.1. <b>Responsabilidade do CONTRATANTE como Controlador.</b> O
        CONTRATANTE é o único responsável por definir as finalidades, garantir a
        existência de base legal adequada e obter os consentimentos necessários
        para o tratamento dos dados pessoais que ele e seus Clientes Finais
        inserem na plataforma, bem como pela licitude e exatidão de tais dados,
        obrigando-se a indenizar e isentar a CONTRATADA de quaisquer reclamações,
        autuações ou penalidades decorrentes do descumprimento dessas obrigações.
      </p>
      <p>
        20.8. <b>Operação White Label hospedada e cadeia de tratamento de dados:</b>
        na operação White Label hospedada pela CONTRATADA, as partes reconhecem a
        seguinte cadeia de tratamento de dados pessoais:
      </p>
      <p>
        a) O CONTRATANTE atua como <b>Controlador</b> dos dados pessoais inseridos
        por ele e por seus Clientes Finais nas subcontas, definindo as finalidades
        específicas do tratamento;
      </p>
      <p>
        b) A CONTRATADA atua como <b>Operadora</b> quando trata dados em nome do
        CONTRATANTE para a execução dos serviços contratados, e como Controladora
        apenas quanto aos dados cadastrais do CONTRATANTE e aos metadados
        operacionais necessários ao monitoramento previsto na cláusula 19.3;
      </p>
      <p>
        c) Eventual qualificação da CONTRATADA como Controladora Conjunta pela
        ANPD ou autoridade judicial, em razão da definição de meios essenciais de
        tratamento, gera <b>direito de regresso integral em favor da CONTRATADA
        contra o CONTRATANTE</b> pela parcela das responsabilidades atribuível ao
        tratamento por ele determinado.
      </p>
      <p>
        20.8.1. <b>Obrigação de back-to-back com Cliente Final:</b> o CONTRATANTE
        White Label obriga-se a celebrar com cada Cliente Final instrumento
        contratual que contenha, no mínimo:
      </p>
      <p>a) Identificação clara das finalidades do tratamento dos dados pessoais;</p>
      <p>
        b) Obrigações do Cliente Final compatíveis com as obrigações assumidas
        pelo CONTRATANTE perante a CONTRATADA neste instrumento, especialmente
        quanto a segurança da informação, comunicação de incidentes em até 24
        (vinte e quatro) horas e cooperação no atendimento de requisições de titulares;
      </p>
      <p>
        c) Vedação ao Cliente Final de realizar tratamento de dados pessoais para
        finalidades diversas das declaradas;
      </p>
      <p>
        d) Cláusula de regresso integral em favor do CONTRATANTE em caso de
        descumprimento pelo Cliente Final.
      </p>
      <p>
        20.8.2. O descumprimento da obrigação prevista na cláusula 20.8.1
        caracteriza violação contratual grave e sujeita o CONTRATANTE à integral
        responsabilização perante a CONTRATADA por eventuais autuações,
        indenizações ou penalidades aplicadas pela ANPD ou autoridades judiciais
        decorrentes de incidentes envolvendo seus Clientes Finais.
      </p>
      <p>
        20.9. <b>Transferência internacional de dados.</b> O CONTRATANTE reconhece
        e autoriza que, para a prestação dos serviços, os dados pessoais poderão
        ser tratados em servidores e por provedores localizados fora do Brasil,
        notadamente nos Estados Unidos da América (infraestrutura de hospedagem e
        provedores de modelos de IA acessados via API). A CONTRATADA compromete-se
        a adotar, com cada suboperador localizado no exterior, mecanismo de
        transferência internacional compatível com a LGPD, em especial as
        Cláusulas-Padrão Contratuais aprovadas pela Resolução CD/ANPD nº 19/2024,
        ou outro mecanismo reconhecido pela ANPD como equivalente, assegurando
        nível de proteção adequado aos dados transferidos.
      </p>
      <p>
        20.10. <b>Suboperadores e demais terceiros.</b> O CONTRATANTE autoriza o
        uso, pela CONTRATADA, dos suboperadores e terceiros necessários à
        prestação dos serviços, comprometendo-se a CONTRATADA a impor-lhes
        obrigações de proteção compatíveis com este instrumento e a comunicar
        previamente alterações relevantes, facultada a oposição justificada pelo
        CONTRATANTE. Compreendem-se, entre outros: provedor de infraestrutura/
        hospedagem; provedores de modelos de inteligência artificial (LLMs)
        acessados via API; provedores de mensageria (incluindo APIs oficial e não
        oficial do WhatsApp, Messenger e Instagram); e processador de pagamentos.
      </p>
      <p>
        20.11. <b>Medidas de segurança.</b> A CONTRATADA adota medidas técnicas e
        organizacionais comercialmente razoáveis e compatíveis com os padrões
        usuais da indústria, entre elas: armazenamento criptografado das mensagens
        de WhatsApp, Instagram e Messenger; criptografia de chaves de API e
        segredos; proteção das conexões em trânsito; controle de acesso baseado em
        credenciais; e segregação lógica de dados entre subcontas. A CONTRATADA
        aprimora continuamente tais medidas, sem que isso constitua garantia
        absoluta de inviolabilidade, conforme cláusula 14.2.
      </p>
      <p>
        20.12. <b>Dados sensíveis e de crianças e adolescentes.</b> Quando o
        CONTRATANTE ou seus Clientes Finais tratarem dados pessoais sensíveis (por
        exemplo, dados de saúde ou financeiros), o CONTRATANTE, na qualidade de
        Controlador, é o responsável pela respectiva base legal (art. 11 da LGPD) e
        pelos consentimentos específicos eventualmente exigidos, obrigando-se a
        CONTRATADA a aplicar medidas reforçadas de segurança. O tratamento de dados
        de crianças e adolescentes observará o art. 14 da LGPD; o CONTRATANTE que
        vier a operar nesse contexto deverá comunicar previamente a CONTRATADA e
        garantir o melhor interesse do menor e o consentimento específico de ao
        menos um dos pais ou responsável legal.
      </p>
      <p>
        20.13. <b>Encarregado pelo Tratamento de Dados Pessoais (DPO):</b> Sergio
        Zaninotti, contato pelo e-mail contato@mercadoagentes.com, a quem os
        titulares poderão dirigir requisições e dúvidas relativas ao tratamento de
        seus dados pessoais.
      </p>
      <p>
        20.14. <b>Segregação de dados em ambiente multi-tenant:</b> a CONTRATADA
        implementa controles técnicos e organizacionais para garantir a segregação
        lógica de dados entre as diferentes subcontas operadas na plataforma, em
        conformidade com os padrões usuais da indústria de SaaS multi-tenant. O
        CONTRATANTE reconhece, contudo, que a segregação lógica é distinta da
        segregação física, e que eventuais vulnerabilidades exploradas mediante
        recursos tecnológicos superiores aos padrões usualmente aceitáveis
        sujeitam-se ao regime de responsabilidade previsto na cláusula 14.2.
      </p>

      {/* CLÁUSULA 21 - DISPOSIÇÕES GERAIS */}
      <h5><u>21. Disposições Gerais</u></h5>
      <p>
        21.1. Estes termos regem a relação entre o MercadoAgentes e o CONTRATANTE.
        Eles não criam quaisquer direitos para terceiros. As partes
        comprometem-se a conduzir suas atividades em conformidade com princípios
        de ética, integridade e boa-fé.
      </p>
      <p>
        21.2. O CONTRATANTE reconhece que todo o código-fonte, design, marcas e
        elementos da plataforma são de titularidade exclusiva da CONTRATADA,
        sendo vedada sua reprodução, engenharia reversa ou uso para
        desenvolvimento de software concorrente.
      </p>
      <p>
        21.3. Caso o CONTRATANTE não cumpra estes termos e nós não tomemos
        providências imediatas, isso não significa que estamos renunciando a
        quaisquer direitos que possamos ter (como tomar providências futuras).
        Caso uma condição específica destes termos não seja executável, isso não
        prejudicará quaisquer outros termos.
      </p>
      <p>
        21.4. O presente contrato é firmado em caráter irrevogável e irretratável,
        ressalvado o direito à rescisão na forma e hipóteses previstas neste
        instrumento, respondendo as partes por si e seus sucessores, na forma da
        lei.
      </p>
      <p>
        21.5. O presente contrato será regido pelas leis brasileiras, ficando eleito o
        Foro da Comarca de Balneário Camboriú, Estado de Santa Catarina, com
        expressa renúncia de qualquer outro, por mais privilegiado que seja.
      </p>
      <p>
        21.6. As partes elegem a comunicação por e-mail como forma válida de
        notificação para todos os fins deste contrato, desde que enviada aos
        endereços cadastrados.
      </p>

      <button
        type="button"
        className="btn btn-sm btn-secondary float-right"
        style={{ minWidth: 260 }}
        onClick={() => props.setShowModal(false)}
      >
        Fechar
      </button>
    </div>
  );
}
